import PublicLayout from "@/components/public-layout";
import { enWords, Locale } from "@/locales/dict";

type Props = {
  serverSideProps: {
    words: typeof enWords;
    locale: Locale;
  };
};

export default function Reserve(props: Props) {
  return (
    <PublicLayout
      words={props.serverSideProps.words.navBar}
      locale={props.serverSideProps.locale}
      activePage={"/reserve"}
    >
      <iframe
        className="my-8"
        id="meraki-restaurante"
        title="Reservas"
        src={`https://www.covermanager.com/reserve/module_restaurant/meraki-restaurante/${props.serverSideProps.locale === "es" ? "spanish" : "english"}`}
        allow="payment"
        height="100%"
        width="100%"
      ></iframe>
    </PublicLayout>
  );
}
